module.exports = __webpack_public_path__ + "static/media/conversao.c8a1907e.png";